import { createApp, h } from 'vue'
import { createPinia, setMapStoreSuffix } from 'pinia'
import { InertiaProgress } from '@inertiajs/progress'
import { createInertiaApp } from '@inertiajs/inertia-vue3'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import "vue3-easy-data-table/dist/style.css";

setMapStoreSuffix('Store')
const pinia = createPinia()
pinia.use(({ store }) => {
  store.$trans = trans;
});

InertiaProgress.init()

createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  title: title => title ? `${title} - Matchmaker` : 'Matchmaker',
  setup({ el, App, props, plugin }) {
    const vueApp = createApp({ render: () => h(App, props) })

    vueApp.config.globalProperties.$trans = trans;
    vueApp.config.globalProperties.$config = window.config;
    vueApp.config.globalProperties.$user = window.user;
    vueApp.config.globalProperties.$moment = window.moment;
    vueApp.config.globalProperties.$functions = window.functions;

    vueApp.use(pinia)
      .use(plugin)
      .use(ElementPlus)
      .mount(el)
  },
})
